import React from 'react'
import { Container } from 'reactstrap'
import ProductList from '../components/Products/ProductList';

const PurchaseListings = () => {
  return (
    <>
      <Container>
        <ProductList />
      </Container>
    </>
  )
}

export default PurchaseListings